import React from "react";
import { ptBR } from "date-fns/locale";
import * as S from "./styles";
import * as IconsSVG from "../../assets/iconsSVG";
import MaterialUI from "../../material-UI";
import { FilterDateRangeProps } from "./types";

const DatePickerRangeG: React.FC<FilterDateRangeProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  width,
  disabled,
  minDate,
  error,
  helperText,
}) => {
  return (
    <S.LocalizationProvider
      locale={ptBR}
      dateAdapter={MaterialUI.AdapterDateFns}
    >
      <S.Row style={{ width }}>
        <S.ContentDate>
          <S.DesktopDatePicker
            inputFormat="dd/MM/yyyy"
            value={startDate}
            components={{
              OpenPickerIcon: IconsSVG.CalendarIcon,
            }}
            disabled={disabled}
            InputAdornmentProps={{ position: "start" }}
            onChange={(newValue: any) => onStartDateChange(newValue)}
            maxDate={endDate || undefined}
            renderInput={(params: any) => (
              <>
                <S.LabelText>De</S.LabelText>
                <S.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="De"
                  fullWidth
                />
              </>
            )}
          />
        </S.ContentDate>
        <S.ContentDate>
          <S.DesktopDatePicker
            inputFormat="dd/MM/yyyy"
            value={endDate}
            disabled={disabled}
            components={{
              OpenPickerIcon: IconsSVG.CalendarIcon,
            }}
            InputAdornmentProps={{ position: "start" }}
            onChange={(newValue: any) => onEndDateChange(newValue)}
            minDate={startDate || minDate || undefined}
            renderInput={(params: any) => (
              <>
                <S.LabelText>Até</S.LabelText>
                <S.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Até"
                  fullWidth
                  error={error}
                  helperText={helperText}
                />
              </>
            )}
          />
        </S.ContentDate>
      </S.Row>
    </S.LocalizationProvider>
  );
};

export default DatePickerRangeG;
